<template>
  <div class="login-container" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <v-row justify="center" class="login-row">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5" class="login-col">
        <v-card class="login-card" elevation="0">
          <div class="login-header">
            <div class="login-icon-wrapper">
              <v-icon :size="iconSize" color="primary" class="login-icon">mdi-account-circle</v-icon>
            </div>
            <v-card-title class="login-title">{{ $t('LogIn') }}</v-card-title>
            <p class="login-subtitle">
              {{ $t('welcome') }}
            </p>
          </div>
          
          <v-card-text class="login-content">
            <v-form @submit.prevent="handleLogin">
              <div class="form-group">
                <label class="form-label">
                  {{ $t('phone_number') }} :
                </label>
                <v-text-field
                  type="tel"
                  density="comfortable"
                  variant="outlined"
                  :placeholder="$t('phone_number')"
                  hide-details="auto"
                  class="login-input tel"
                  elevation="0"
                  v-model="loginForm.phone"
                  @input="validatePhoneNumber"
                  prepend-inner-icon="mdi-phone"
                >
                </v-text-field>
                <div v-if="invalidPhoneNumber" class="error-message">
                  {{ validationMessage }}
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">
                  {{ $t('Password') }} :
                </label>
                <v-text-field
                  :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="visible ? 'text' : 'password'"
                  :placeholder="$t('Password')"
                  density="comfortable"
                  class="login-input"
                  variant="outlined"
                  hide-details="auto"
                  @click:append-inner="visible = !visible"
                  v-model="loginForm.password"
                  prepend-inner-icon="mdi-lock"
                ></v-text-field>
              </div>

              <div v-if="errorMessage" class="error-message main-error">
                <v-icon size="18" class="mr-1">mdi-alert-circle</v-icon>
                {{ errorMessage }}
              </div>

              <div class="login-options">
                <v-checkbox 
                  :label="$t('remember')" 
                  class="remember-checkbox" 
                  hide-details
                  color="primary"
                ></v-checkbox>
                <button 
                  type="button"
                  class="forget-password-btn" 
                  @click="()=>{$router.push('/forget-password') }"
                >
                  {{ $t('ForgetPassword') }}
                </button>
              </div>

              <button type="submit" class="login-btn" :disabled="isLoading">
                <span v-if="!isLoading" class="btn-content">
                  <v-icon size="20" class="btn-icon">mdi-login</v-icon>
                  <span>{{ $t('LogIn') }}</span>
                </span>
                <span v-else class="btn-loading">
                  <v-progress-circular
                    indeterminate
                    color="white"
                    size="20"
                    width="2"
                    class="loading-spinner"
                  ></v-progress-circular>
                  <span>{{ $t('Logging_in') }}</span>
                </span>
              </button>
            </v-form>

            <div class="signup-section">
              <p class="signup-text">
                {{ $t('Dont_account') }}
              </p>
              <button class="signup-btn" @click="create()">
                {{ $t('Create_account') }}
              </button>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import crudDataService from "@/Services/crudDataService";

export default {
  data() {
    return {
      loginForm: {
        phone: "",
        password: "",
        device_token:"1234"
      },
      errorMessage: "",
      visible: false,
      invalidPhoneNumber:false,
      validationMessage:"",
      isLoading: false
    };
  },
  computed: {
    iconSize() {
      if (typeof window !== 'undefined') {
        if (window.innerWidth < 480) return 40;
        if (window.innerWidth < 768) return 44;
      }
      return 48;
    }
  },
  mounted() {
    // Force re-render on window resize
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  methods: {
    handleResize() {
      // Force component update on resize
      this.$forceUpdate();
    },
    validatePhoneNumber() {
      // Simple check to ensure the phone number does not start with a negative sign
      // and contains only digits. You can replace this with a more robust validation if needed.
      const isNegative = this.loginForm.phone.startsWith('-');
      const isNumeric = /^\d+$/.test(this.loginForm.phone);

      this.invalidPhoneNumber = isNegative || !isNumeric;

      // If you have a localization library like vue-i18n, you can use it to switch messages
      this.validationMessage = this.$t('enterValidPhoneNumber');
    },
    async handleLogin() {
      if (this.isLoading) return;
      
      this.isLoading = true;
      this.errorMessage = "";
      
      try {
        const response = await crudDataService.create(`login`, this.loginForm);
        localStorage.setItem('userId', response.data.data.id);
        localStorage.setItem('authToken', response.data.data.token);
        this.$router.push({ name: 'home' });
        window.location.reload();
        
      } catch(error) {
        console.log(error.request);
        console.log(error.response);
        if (error.response) {
          this.errorMessage = error.response.data.message;
        } else if (error.request) {
          this.errorMessage = 'No response from the server';
        } else {
          this.errorMessage = error.message;
        }
        console.error('Login error:', this.errorMessage);
      } finally {
        this.isLoading = false;
        
      }
    },
    create(){
      this.$router.push({name:'Register'})
    }
  },
};
</script>
<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #f5f5f5;
  width: 100%;
  box-sizing: border-box;
}

.login-row {
  width: 100%;
  max-width: 100%;
  margin: 0;
}

.login-col {
  padding: 16px !important;
}

.login-card {
  background: #ffffff !important;
  border-radius: 8px !important;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.login-header {
  text-align: center;
  padding: 24px 20px;
  background: #0074c7;
  color: white;
  box-sizing: border-box;
}

.login-icon-wrapper {
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
}

.login-icon {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  padding: 10px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  width: auto;
  height: auto;
}

.login-title {
  font-size: clamp(20px, 4vw, 24px) !important;
  font-weight: 600 !important;
  color: white !important;
  margin-bottom: 6px !important;
  line-height: 1.3;
}

.login-subtitle {
  font-size: clamp(12px, 2.5vw, 14px);
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
}

.login-content {
  padding: 24px 20px !important;
  box-sizing: border-box;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-weight: 500;
  font-size: clamp(13px, 2.5vw, 14px);
  color: #333;
  margin-bottom: 8px;
  line-height: 1.4;
}

.login-input {
  :deep(.v-field) {
    border-radius: 6px !important;
    border: 1px solid #e0e0e0 !important;
    transition: all 0.2s ease;
    background: #ffffff !important;

    &:hover {
      border-color: #0074c7 !important;
    }

    &.v-field--focused {
      border-color: #0074c7 !important;
      box-shadow: 0 0 0 2px rgba(0, 116, 199, 0.1) !important;
    }
  }

  :deep(.v-field__input) {
    padding: 12px 16px !important;
    font-size: clamp(14px, 3vw, 15px);
    color: #333;
    min-height: 44px;
  }

  :deep(.v-field__prepend-inner) {
    padding-inline-start: 16px;
    color: #666;
  }
}

.tel {
  :deep(input) {
    text-align: start !important;
    direction: ltr;
  }
}

.error-message {
  display: flex;
  align-items: center;
  color: #dc3545;
  font-size: 13px;
  margin-top: 6px;
  padding: 8px 12px;
  background: #fee;
  border-radius: 6px;
  border-right: 3px solid #dc3545;

  &.main-error {
    margin-top: 16px;
    margin-bottom: 8px;
  }
}

.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  flex-wrap: wrap;
  gap: 12px;

  [dir="rtl"] & {
    flex-direction: row-reverse;
  }
}

.remember-checkbox {
  :deep(.v-label) {
    font-size: 14px;
    color: #666;
  }
}

.forget-password-btn {
  background: none;
  border: none;
  color: #0074c7;
  font-weight: 500;
  font-size: clamp(13px, 2.5vw, 14px);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    background: rgba(0, 116, 199, 0.1);
    color: #005a9d;
  }
}

.login-btn {
  width: 100%;
  padding: 14px 16px;
  margin-top: 20px;
  background: #0074c7;
  border: none;
  border-radius: 6px;
  color: white;
  font-weight: 500;
  font-size: clamp(15px, 3.5vw, 16px);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 48px;
  box-sizing: border-box;

  &:hover:not(:disabled) {
    background: #005a9d;
    opacity: 0.95;
  }

  &:active:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.btn-content,
.btn-loading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.signup-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  flex-wrap: wrap;
}

.signup-text {
  font-size: clamp(13px, 2.5vw, 14px);
  color: #666;
  margin: 0;
  line-height: 1.4;
}

.signup-btn {
  background: none;
  border: none;
  color: #0074c7;
  font-weight: 600;
  font-size: clamp(13px, 2.5vw, 14px);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    background: rgba(0, 116, 199, 0.1);
    color: #005a9d;
  }
}

@media (max-width: 960px) {
  .login-container {
    padding: 16px;
    align-items: flex-start;
    padding-top: 20px;
  }

  .login-col {
    padding: 12px !important;
  }

  .login-header {
    padding: 20px 16px;
  }

  .login-content {
    padding: 20px 16px !important;
  }
}

@media (max-width: 600px) {
  .login-container {
    padding: 12px;
    padding-top: 16px;
  }

  .login-col {
    padding: 8px !important;
  }

  .login-header {
    padding: 18px 14px;
  }

  .login-icon {
    padding: 8px;
  }

  .login-content {
    padding: 18px 14px !important;
  }

  .form-group {
    margin-bottom: 18px;
  }

  .login-options {
    margin: 16px 0;
    gap: 8px;
  }

  .login-btn {
    padding: 12px 14px;
    margin-top: 16px;
  }

  .signup-section {
    margin-top: 20px;
    padding-top: 16px;
    gap: 6px;
  }
}

@media (max-width: 400px) {
  .login-container {
    padding: 8px;
    padding-top: 12px;
  }

  .login-header {
    padding: 16px 12px;
  }

  .login-content {
    padding: 16px 12px !important;
  }

  .login-btn {
    font-size: 15px;
    padding: 12px;
  }
}
</style>

